import script from "./PDFViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PDFViewer.vue?vue&type=script&setup=true&lang=ts"

import "./PDFViewer.vue?vue&type=style&index=0&id=a9207992&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9207992"]])

export default __exports__